import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useNoPaymentModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { spot } = storage;
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });

  function didOpen() {
    analyticsPageView('Nothing to Pay');
  }

  async function show() {
    const result = await swal.fire({
      icon: 'error',
      title: spot?.prepaid
        ? t('no-payment-modal.title.prepaid')
        : t('no-payment-modal.title'),
      text: ' ',
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: t('close'),
      didOpen,
    });

    return result;
  }

  return {
    showNoPaymentModal: show,
  };
}

export { useNoPaymentModal };
